import { useIsScreenSizeSmall } from "@trueskin-web/theme"

import PlanDetails from "./plan-details"
import PlanImage from "./plan-image"
import PlanVariant from "./plan-variant"

const SinglePurchaseVariant = ({ variant, isSelected, onClick }) => {
  const isMobile = useIsScreenSizeSmall()

  const PriceTitle = (
    <span sx={{ fontWeight: "bold" }}>{variant.priceTitle}</span>
  )

  return (
    <PlanVariant
      isSelected={isSelected}
      title={variant.title}
      description={variant.description}
      priceTitle={PriceTitle}
      showCollapseButton={isMobile}
      onClick={onClick}
      showRadioButton={isMobile}
      expandedByDefault={!isMobile}
    >
      <PlanImage image={variant.image} title={variant.title} />
      <PlanDetails details={variant.details} />
    </PlanVariant>
  )
}

export default SinglePurchaseVariant
